import React, { PropsWithChildren } from 'react';
import { Modal } from 'react-bootstrap';

export default function DialogFooter({
  children,
}: PropsWithChildren) {
  return (
    <Modal.Footer className="dialog-footer">
      {children}
    </Modal.Footer>
  );
}
